<template>
	<svg :class="svgClass" aria-hidden="true" v-on="$listeners">
		<use :xlink:href="iconName" />
	</svg>
</template>

<script>
export default {
	name: 'SvgIcon',
	props: {
		name: {
			type: String,
			required: true
		},
		className: {
			type: String,
			default: ''
		}
	},
	computed: {
		iconName() {
			return `#icon-${this.name}`;
		},
		svgClass() {
			if (this.className) {
				return `svg-icon svg-${this.name} ${this.className}`;
			} else {
				return `svg-icon svg-${this.name}`;
			}
		}
	}
};
</script>

<style scoped>
.svg-icon {
	/* width: 1em; */
	/* height: 1em; */
	/* vertical-align: -0.15em; */
	/* fill: currentColor; */
	/* overflow: hidden; */
}
.svg-arrow6 {
	stroke: #666;
}
.svg-arrow5 {
	stroke: #666;
}
.svg-jiantou4 {
	stroke: #FFFFFF;
}
.svg-back {
	fill: #333333;
}
.svg-arrowdown {
	fill: #333333;
}
.svg-wodeliuyan {
	fill: #FFFFFF;
}
.svg-woyaoliuyan {
	fill: #FFFFFF;
}
.svg-quanbuliuyan {
	fill: #FFFFFF;
}
.svg-youxiang {
	fill: #FFFFFF;
}
.svg-dingwei {
	fill: #FFFFFF;
}
.svg-dianhua {
	fill: #FFFFFF;
}
.svg-wangluo {
	fill: #FFFFFF;
}
.svg-wenben {
	fill: #FFFFFF;
}
.svg-tilu {
	fill: #FFFFFF;
}
.svg-jianyan {
	fill: #FFFFFF;
}
.svg-paginationdot {
	fill: #FFFFFF;
}
.svg-paginationarrow2 {
	stroke: #FFFFFF;
}
.svg-paginationarrow1 {
	stroke: #FFFFFF;
}
.svg-swiperarrow4 {
	stroke: #FFFFFF;
	fill: transparent;
	/* fill: $primary; */
}
.svg-swiperarrow3 {
	stroke: #FFFFFF;
	fill: transparent;
	/* fill: $primary; */
}
.svg-swiperarrow2 {
	stroke: #FFFFFF;
}
.svg-swiperarrow1 {
	stroke: #FFFFFF;
}
.svg-fangdajing2 {
	fill: #262323;
}
.svg-jiantou {
	stroke: #FFFFFF;
}
.svg-fangdajing {
	fill: #FFFFFF;
}
.svg-logo {
	fill: #FFFFFF;
}
</style>
